import React, { useState, useEffect } from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import efg from "../../Assets/Cert/efg.png"; // Make sure this path is correct
import "./style.css";

const Certificate = ({ candidate }) => {
   const today = new Date();
    const courseDate = today.toLocaleDateString("en-GB"); // DD/MM/YYYY
  if (!candidate) return null;

  const {
    Name,
    NricId,
    SerialNo,
    CourseName,
    CourseStartDate,
    CourseEndDate,
  } = candidate;

  const formattedStart = new Date(CourseStartDate).toLocaleDateString("en-GB");
  const formattedEnd = new Date(CourseEndDate).toLocaleDateString("en-GB");

  return (
    <div
      className="certificate-container"
      id={`certificate-${NricId}`}
      style={{
        width: "210mm",
        padding: "20mm",
        background: "white",
        color: "black",
      }}
    >
      <div className="certificate-header">
        <div className="logo">
          <img src={efg} alt="cert" width={80} />
        </div>
        <div className="company-name">EFG TRAINING SERVICES PRIVATE LTD</div>
      </div>

      <div className="serial">Serial no: {SerialNo}</div>

      <div className="certificate-body">
        <h1>Certificate</h1>
        <p className="completion">of Completion</p>
        <p className="learning">Asynchronous Learning</p>
        <h2 className="course-title-cert">{CourseName}</h2>

        <p className="presented">This certificate is proudly presented to</p>
        <h2 className="student-name">
          {Name} ({NricId})
        </h2>

        <p className="cert-details bottom-confirmation">
          This certifies that the above-named individual has successfully
          completed the <strong>{CourseName}</strong> through{" "}
          <strong>Asynchronous Learning</strong> and is deemed{" "}
          <strong>Competent</strong>.
        </p>

        <div className="footer">
          <div className="left">
            Course date: {courseDate}
          </div>

          <div className="center-image">
            <img
              src={require("../../Assets/Cert/stamp.jpeg")}
              alt="stamp"
              className="stamp-img"
            />
          </div>

          <div className="right">
            <img
              src={require("../../Assets/Cert/sign.jpeg")}
              alt="signature"
              className="signature-img"
            />
            <br />
            <strong>Rosli Bin Pitchay</strong>
            <br />
            Director / Principal
          </div>
        </div>
      </div>

      <div className="company-footer">
        EFG Training services Private Ltd | No: 3, Soon Lee Street, 01-16,
        Pioneer Junction, Singapore – 627606
        <br />
        Email: <a href="mailto:admin@efg.com.sg">admin@efg.com.sg</a> | Phone: +65
        6334 7872 / 91814091
      </div>
    </div>
  );
};

const AdminFilterAllCandidates = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [batchList, setBatchList] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [certificateCandidate, setCertificateCandidate] = useState(null);

  useEffect(() => {
    const fetchBatchList = async () => {
      try {
        const response = await axios.get(
          "https://elearn-api.onrender.com/api/getBatchNo"
        );
        const data = response.data;

        if (Array.isArray(data)) {
          const batches = data.map((item) => item.BatchNo);
          setBatchList(batches);
        } else {
          setBatchList([]);
          console.warn("Unexpected response format");
        }
      } catch (error) {
        console.error("Failed to fetch batch list:", error);
        setBatchList([]);
      }
    };

    fetchBatchList();
  }, []);

  const formatDateForAPI = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return null;
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  // Group and summarize candidate results
  const groupedResults = results.reduce((acc, curr) => {
    const key = curr.NricId;

    if (!acc[key]) {
      acc[key] = {
        NricId: curr.NricId,
        Name: curr.Name,
        PassMark: curr.Pass || 60,
        TotalQuestions: 0,
        TotalMarks: 0,
      };
    }

    acc[key].TotalQuestions += 1;
    acc[key].TotalMarks += Number(curr.Marks || 0);

    return acc;
  }, {});

  const summaryData = Object.values(groupedResults).map((item) => {
    const percentage =
      item.TotalQuestions > 0
        ? (item.TotalMarks / item.TotalQuestions) * 100
        : 0;
    return {
      ...item,
      Percentage: percentage.toFixed(2),
      Passed: percentage >= item.PassMark,
    };
  });

  const handleSearchAll = () => {
    if (!startDate || !endDate || !batchNo) {
      alert("Please select start date, end date, and batch number.");
      return;
    }

    const formattedStart = formatDateForAPI(startDate);
    const formattedEnd = formatDateForAPI(endDate);

    if (!formattedStart || !formattedEnd) {
      alert("Invalid date format");
      return;
    }

    const url = `https://elearn-api.onrender.com/api/mcq-summary-admins-all?startDate=${encodeURIComponent(
      formattedStart
    )}&endDate=${encodeURIComponent(
      formattedEnd
    )}&batchNo=${batchNo}`;

    setLoading(true);
    setError("");
    setResults([]);

    axios
      .get(url)
      .then((res) => {
        const data = res.data;

        if (data && Array.isArray(data) && data.length > 0) {
          setResults(data);
          setError("");
        } else {
          setError("No data found");
          setResults([]);
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        setError("Error fetching data");
        setResults([]);
      })
      .finally(() => setLoading(false));
  };

  // Download PDF certificate for candidate
  const handleDownloadCertificate = async (nricId) => {
    try {
      const response = await axios.get(
        `https://elearn-api.onrender.com/api/getCandidateDetails?batchNo=${batchNo}&nricId=${nricId}`
      );
      if (response.data && response.data.length > 0) {
        const candidate = response.data[0];
        setCertificateCandidate(candidate);
        setTimeout(() => {
          const input = document.getElementById(`certificate-${candidate.NricId}`);
          if (!input) {
            alert("Certificate rendering failed.");
            return;
          }
          html2canvas(input, { scale: 2, useCORS: true }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              pdf.addPage();
              pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
            }

            pdf.save(`${candidate.Name}_Certificate.pdf`);
          });
        }, 500);
      } else {
        alert("Candidate certificate data not found.");
      }
    } catch (err) {
      console.error("Certificate download error:", err);
      alert("Failed to download certificate.");
    }
  };

  return (
    <div className="admin-filter-container">
      <h2>Candidate Summary - Admin (All Candidates)</h2>

      <div className="filter-form">
        <div className="form-group">
          <label>Course Start Date:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Course End Date:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Batch No:</label>
          <select value={batchNo} onChange={(e) => setBatchNo(e.target.value)}>
            <option value="">-- Select Batch --</option>
            {batchList.map((b, idx) => (
              <option key={idx} value={b}>
                {b}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <button
            disabled={loading}
            onClick={handleSearchAll}
            className="admin-btn"
          >
            {loading ? "Loading..." : "Search All Candidates"}
          </button>
        </div>
      </div>

      {error && <div className="error">{error}</div>}

      {summaryData.length > 0 && (
        <table className="results-table">
          <thead>
            <tr>
              <th>Candidate Name</th>
              <th>Total Questions</th>
              <th>Total Marks</th>
              <th>Percentage (%)</th>
              <th>Status</th>
              <th>Certificate</th>
            </tr>
          </thead>
          <tbody>
            {summaryData.map((candidate) => (
              <tr key={candidate.NricId}>
                <td>{candidate.Name}</td>
                <td>{candidate.TotalQuestions}</td>
                <td>{candidate.TotalMarks.toFixed(2)}</td>
                <td>{candidate.Percentage}</td>
                <td className={candidate.Passed ? "pass" : "fail"}>
                  {candidate.Passed ? "Pass" : "Fail"}
                </td>
                <td>
                  {candidate.Passed && (
                    <button
                      onClick={() => handleDownloadCertificate(candidate.NricId)}
                      className="cert-btn"
                    >
                      Download Certificate
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Offscreen certificate rendering for PDF capture */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        {certificateCandidate && <Certificate candidate={certificateCandidate} />}
      </div>
    </div>
  );
};

export default AdminFilterAllCandidates;
